import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import ReactCSVReader from 'react-csv-reader';

import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles((theme) => ({
  csvContainer: {
    textAlign: 'center',
    padding: theme.spacing(2),
    margin: `${theme.spacing(1)} auto`,
  },
  csvInput: {
    padding: theme.spacing(1),
    display: 'block',
    margin: `${theme.spacing(2)} auto`,
    border: '1px solid #ccc',
    borderRadius: 5,
    outline: 'none',
  },
}));

const CSVReader = (props) => {
  const { title, subtitle, onFileLoaded } = props;
  const classes = useStyles();
  const [error, setError] = useState();

  const handleFileLoaded = useCallback(
    (data) => {
      onFileLoaded(data);
      setError();
    },
    [onFileLoaded]
  );

  const handleOnError = useCallback((newError) => {
    setError(newError);
  }, []);

  return (
    <div className={classes.csvContainer}>
      <Typography variant="body1">{title}</Typography>
      <Typography variant="caption">{subtitle}</Typography>
      {error && (
        <Typography variant="subtitle2" color="error">
          {error}
        </Typography>
      )}
      <ReactCSVReader
        cssInputClass={classes.csvInput}
        onFileLoaded={handleFileLoaded}
        onError={handleOnError}
      />
    </div>
  );
};

CSVReader.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,

  onFileLoaded: PropTypes.func.isRequired,
};

CSVReader.defaultProps = {
  title: undefined,
  subtitle: undefined,
};

export default CSVReader;
